import JoinZoomButton from "@/ui/components/schedule/JoinZoomButton";
import { Text } from "@/ui/core";
import { Box, HStack, StatusBarPadding, VStack } from "@/ui/layout";
import { ColorToken, LayoutToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface JoinEventBannerProps {
  endDate: string;
  eventId: string;
  eventTitle: string;
  isGroupClass?: boolean;
  isPhoneCallEvent?: boolean;
  location?: "liveEvent" | "waitingRoom";
  patientId?: string;
  startDate: string;
  timeRange: string;
}

const baseTestID = "join-event-banner";

const LiveEventDetails = ({
  eventTitle,
  timeRange,
}: Pick<JoinEventBannerProps, "eventTitle" | "timeRange">) => {
  return (
    <VStack flexShrink={1} gap={2}>
      <HStack alignItems="center" gap={8}>
        <HStack alignItems="center" gap={4}>
          <Box
            backgroundColor={ColorToken.AccentLime}
            borderRadius={6}
            height={6}
            width={6}
          />
          <Text
            color={ColorToken.AccentLime}
            testID={joinTestIDs(baseTestID, "live-now")}
            variant="body"
          >
            Live now
          </Text>
        </HStack>
        <Text
          color={ColorToken.NeutralBackgroundPrimary}
          testID={joinTestIDs(baseTestID, "time-range")}
          variant="caption"
        >
          {timeRange}
        </Text>
      </HStack>
      <Text
        color={ColorToken.NeutralBackgroundPrimary}
        numberOfLines={1}
        testID={joinTestIDs(baseTestID, "message")}
        variant="bodyMedium"
      >
        {eventTitle}
      </Text>
    </VStack>
  );
};

const JoinEventBanner = ({
  endDate,
  eventId,
  eventTitle,
  isGroupClass,
  isPhoneCallEvent,
  location = "liveEvent",
  patientId,
  startDate,
  timeRange,
}: JoinEventBannerProps) => {
  return (
    <Box>
      <StatusBarPadding backgroundColor={ColorToken.Primary100} />
      <Box
        backgroundColor={ColorToken.Primary100}
        paddingHorizontal={LayoutToken.ContentPaddingHorizontal}
        paddingVertical={20}
      >
        <HStack alignItems="center" gap={18} justifyContent="space-between">
          <LiveEventDetails eventTitle={eventTitle} timeRange={timeRange} />
          <JoinZoomButton
            endDate={endDate}
            eventId={eventId}
            eventTitle={eventTitle}
            hasIcon
            isGroupClass={isGroupClass}
            isPhoneCallEvent={isPhoneCallEvent}
            location={location}
            patientId={patientId}
            size="normal"
            startDate={startDate}
            variant="accent.lime"
          />
        </HStack>
      </Box>
    </Box>
  );
};

export type { JoinEventBannerProps };
export default JoinEventBanner;
